import { useEffect, useState } from 'react';
import { subscribe } from 'valtio';

export function hasVisibleGlobalAhu(controller) {
  return Boolean(
    controller?.ahu_info?.ahui?.some(
      (unit) => String(unit.zone) === '254' && Number(unit.show_this_unit) === 1
    )
  );
}

export function useVisibleGlobalAhu(controller) {
  const [visible, setVisible] = useState(() => hasVisibleGlobalAhu(controller));

  useEffect(() => {
    setVisible(hasVisibleGlobalAhu(controller));
    if (!controller) return undefined;

    return subscribe(controller, () => {
      setVisible(hasVisibleGlobalAhu(controller));
    });
  }, [controller]);

  return visible;
}
